<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-66 md-xsmall-size-80 mx-auto">
      <simple-wizard>
        <template slot="header">
          <h3 class="title">Nueva Reclamación</h3>
          <h5 class="category">Esta información nos ayudará a mejorar nuestros procesos.</h5>
        </template>

        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">Productos</template>
          <third-step ref="step1" @on-validated="onStepValidated"></third-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step2')">
          <template slot="label">Incidencia</template>
          <fourth-step ref="step2" @on-validated="wizardComplete"></fourth-step>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>
<script>
import FirstStep from "./Wizard/FirstStep.vue";
import SecondStep from "./Wizard/SecondStep.vue";
import ThirdStep from "./Wizard/ThirdStep.vue";
import FourthStep from "./Wizard/FourthStep.vue";
import swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  data() {
    return {
      wizardModel: {}
    };
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,
    SimpleWizard,
    WizardTab
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    wizardComplete() {
      swal({
        title: "¡La reclamación ha sido registrada!",
        text: "En breve nos pondremos manos a la obra.",
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
      this.goBack();
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    }
  }
};
</script>
